// removed by extract-text-webpack-plugin
module.exports = {"recipeList":"style__recipeList___1K6xA","recipeItem":"style__recipeItem___13r2R","title":"style__title___2vIsZ","tilt":"style__tilt___2kLyd","visible":"style__visible___2JJVq","hidden":"style__hidden___11K7z"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/recipeList/style.scss
 ** module id = 121
 ** module chunks = 0
 **/